<template>
    <div class="order-table">
        <el-table :data="tableData" v-loading="loading" border size="mini" :header-cell-style="headerCellStyle" :height="tableHeight" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="40" align="left" v-if="checkRole('cgy_role') && pageFlag == 'srmXjOrder'"> </el-table-column>
			<el-table-column type="selection" width="40" align="left" v-else-if="pageFlag == 'noticeAward'"> </el-table-column>
            <el-table-column prop="xjOrder" fixed label="采购单号" width="135">
                <template slot-scope="scope">
                    <router-link :to="{name:'SrmXjOrderDetail',query:{hId:scope.row.id,show:false}}">
                        {{scope.row.xjOrder}}
                    </router-link>
                </template>
            </el-table-column>

            <!-- <el-table-column prop="bjJzTime" fixed label="报价截止时间" width="150">
                <template slot-scope="scope">
                    <a @click="form=scope.row;drawer = true">
                        {{scope.row.bjJzTime}}
                    </a>
                </template>
            </el-table-column> -->
            <el-table-column prop="buyerUnitName" label="采购组织" :show-overflow-tooltip="false"></el-table-column>
            <el-table-column prop="title" label="采购标题" :show-overflow-tooltip="true"></el-table-column>
            <!-- <el-table-column prop="ywSt" label="业务实体" :show-overflow-tooltip="true" width="120"></el-table-column> -->
            <!-- <el-table-column prop="djType" label="单据类型" :show-overflow-tooltip="true" width="80"></el-table-column> -->
            <el-table-column prop="xjFs" label="采购方式" :show-overflow-tooltip="false" :formatter="formatXjtype" width="75"> </el-table-column>
            <!-- <el-table-column prop="biddingFx" label="竞价方向" :show-overflow-tooltip="true" width="80"> </el-table-column> -->
            <el-table-column prop="currency" label="币种" width="60" align="center" :formatter="formatCurrency"> </el-table-column>
            <el-table-column prop="isConcatTax" label="是否含税" align="center" width="70"> </el-table-column>
            <el-table-column prop="userName" label="采购员" align="center" :show-overflow-tooltip="true" width="65"> </el-table-column>
            <el-table-column prop="unitName" label="采购部门" align="center" width="70"> </el-table-column>
            <el-table-column prop="rounds" label="轮次" align="center" width="45"></el-table-column>
            <el-table-column prop="bjStarTime" label="本轮采购开始时间" align="center" width="140"></el-table-column>
            <el-table-column prop="bjEndTime" label="本轮采购结束时间" align="center" width="140"></el-table-column>
			<el-table-column prop="isZdXj" label="是否整单报价"   width="95px" align="center" >
			    <template slot-scope="scope">
					<el-switch v-if="checkRole('cgy_role') && scope.row.orderState == 1" @change="switchChange(scope.row)"
					v-model="scope.row.isZdXj" active-value="是" inactive-value="否"></el-switch>
					<span v-else>{{scope.row.isZdXj}}</span>
			    </template>
			</el-table-column>
            <el-table-column prop="orderState" label="状态" :formatter="formatStatus"></el-table-column>
            <el-table-column prop="createTime" label="发布日期"  :formatter="dateFormatter" :show-overflow-tooltip="false" width="100"> </el-table-column>
		    <el-table-column prop="remark" label="备注" :show-overflow-tooltip="true"> </el-table-column>
            <!-- <el-table-column prop="openRule" label="公开规则" :show-overflow-tooltip="true" width="80"> </el-table-column> -->
            <!-- <el-table-column prop="biddingSort" label="竞价排名" :show-overflow-tooltip="true" width="80"> </el-table-column> -->

            <el-table-column label="操作" align="left" width="150px" fixed="right">
                <template slot-scope="scope">
                    <el-button type="text" v-if="checkRole('cgy_role') && scope.row.orderState == 1" size="small" @click="tableHandle(scope.row,'edit')">修改 </el-button>
                    <el-button type="text" v-if="checkRole('cgy_role') && scope.row.orderState == 1" size="small" @click="tableHandle(scope.row,'del')">删除 </el-button>
                    <el-button type="text" size="small" @click="tableHandle(scope.row,'enquiry')">采购单明细 </el-button>
                    <el-button type="text" v-if="checkRole('gys_role') && scope.row.gysOrderState == 1" size="small" @click="tableHandle(scope.row,'abandon')">放弃</el-button>
                    <el-button type="text" v-if="checkRole('gys_role') && scope.row.gysOrderState == 1" size="small" @click="tableHandle(scope.row,'join')">参与</el-button>
                    <el-button type="text" v-if="checkRole('gys_role') && scope.row.gysOrderState == 3" size="small" @click="tableHandle(scope.row,'submitQuote')">提交报价</el-button>
                    <el-button type="text" v-if="checkRole('cgy_role') && scope.row.orderState >= 4" size="small" @click="tableHandle(scope.row,'info')">审核详情</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-row type="flex" justify="end" class="mg-t5">
            <pagination v-show="count>0" @on-pagination="onPagination" :page.sync="page"
                :limit.sync="limit" :total="count">
            </pagination>
        </el-row>
    </div>
</template>
<script>
    import { xjtypes } from'../../utils/dict'
	import {
		editSrmXjOrder
	} from '@/api/srm/srmXjOrder.js'
    export default {
        name: 'OrderTable',
        props:['tableData','count','tableHeight','page','limit','pageFlag','currencyObj','loading'],
        data(){
            return {
                // page: 1, //当前页码
                // limit: 20, //当前每页显示的数量
            }
        },
        computed:{
            PAGESIZE:function(){
                return this.$store.getters['app/sizeInfo'];

            },
            userRoles:function(){
                return this.$store.getters['user/roles'];
            },
        },
        methods:{
            // 勾选
            handleSelectionChange(val) {
				let ids = [];
				for (let item of val) {
					ids.push(item.id);
                }
                this.$emit('callback',{type:'selecttable',info:ids})
            },
            // 表格操作
            tableHandle: function(row,type){
                this.$emit('callback',{type:type,info:row})
            },
            // 状态值转换
            formatStatus: function(row) {
                let stateObj = {};
                if(this.checkRole('cgy_role')){
                    // 1:待询价,2:询价中,3:已结束询价待审批,4:询价审批中,5:定标审批被驳回,6:定标审批通过,7:已发布中标通知,
                    stateObj = {
                        's_1':'待询价',
                        's_2':'询价中',
                        's_3':'待定标',
                        's_4':'定标审批中',
                        's_5':'定标审批被驳回',
                        's_6':'定标审批通过',
                        's_7':'已发布中标通知',
                        's_8':'已生成合同',
                    }
                    return stateObj[`s_${row.orderState}`];
                }else if(this.checkRole('gys_role')){
                    // 1:待参与,2:已放弃,3:报价中,4:报价已提交,5:已中标,6:未中标,
                    stateObj = {
                        's_1':'待参与',
						's_-1':'已过期',
                        's_2':'已放弃',
                        's_3':'报价中',
                        's_4':'报价已提交',
                        's_5':'已中标',
                        's_6':'未中标',
                    }
                    return stateObj[`s_${row.gysOrderState}`];
                }


            },
            // 页码切换
            onPagination: function(val) {
                this.$emit('callback',{type:'pagination',info:val})
            },
            formatCurrency: function(row) {
				return this.currencyObj[row.currency];
            },
            formatXjtype:function(row){
                let str = '';
                xjtypes.forEach((item)=>{
                    if(item.code == row.xjFs){
                        str = item.name;
                    }
                });
                return str;
            },
            switchChange:function(row){
              let _this=this;
              editSrmXjOrder({id:row.id,isZdXj:row.isZdXj}).then(response => {
                if (response.data.code === 0) {
                  _this.$success(response.data.msg);
                  _this.$emit('callback',{type:'refresh'})
                } else {
                  _this.$fail(response.data.msg);
                }
              });
            },
            dateFormatter(row, column, cellValue) {
              const date = cellValue instanceof Date ? cellValue : new Date(cellValue);
              const year = date.getFullYear();
              const month = (date.getMonth() + 1).toString().padStart(2, '0');
              const day = date.getDate().toString().padStart(2, '0');
              return `${year}-${month}-${day}`;
            },
        }
    }
</script>
<style lang="scss" scoped>
</style>
